module.exports = __webpack_public_path__ + "img/ko-kr.f1a76ae5.svg";